import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const RegistrationTypeCard = ({ icon, title, description, features, buttonText, onClick }) => {
  return (
    <div className="glass-container rounded-2xl p-8 hover:shadow-glass-lg transition-all duration-300 hover:scale-105 cursor-pointer group"
         onClick={onClick}>
      <div className="space-y-6">
        {/* Icon */}
        <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
          <Icon name={icon} size={32} className="text-primary" />
        </div>

        {/* Title & Description */}
        <div className="space-y-2">
          <h3 className="text-2xl font-bold text-foreground">{title}</h3>
          <p className="text-muted-foreground">{description}</p>
        </div>

        {/* Features */}
        <ul className="space-y-3">
          {features?.map((feature, index) => (
            <li key={index} className="flex items-start gap-2">
              <Icon name="Check" size={20} className="text-success mt-0.5 flex-shrink-0" />
              <span className="text-sm text-foreground">{feature}</span>
            </li>
          ))}
        </ul>

        {/* Button */}
        <Button
          variant="default"
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
          className="mt-4"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default RegistrationTypeCard;